import { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useFiltersContext } from '@spotahome/ui-library/src/tenant/context/FiltersContext';

import { generateTitleElems } from './utils';

import './SearchTitle.scss';

const SearchSEOTitle = ({
  seoTitle,
  totalResults = 0,
  cityName,
  size = 'small'
}) => {
  const { filters } = useFiltersContext();
  const topology = filters['topology[]'];
  const types = filters['type[]'] || [];
  const initialTotalResults = useRef(totalResults);
  const hasResultsUpdated = totalResults !== initialTotalResults.current;

  const titleClassname = classNames('search-title__title', {
    'search-title__title--big': size === 'big',
    'search-title__title--small': size === 'small'
  });

  return (
    <div className="search-title">
      {hasResultsUpdated ? (
        <h1 className={titleClassname} data-test="search-title">
          <strong data-test="search-title-total-count">{totalResults}</strong>{' '}
          {generateTitleElems(types, cityName, null, topology)}
        </h1>
      ) : (
        <h1 className={titleClassname} data-test="search-title">
          {seoTitle}
        </h1>
      )}
    </div>
  );
};

export default SearchSEOTitle;

SearchSEOTitle.propTypes = {
  totalResults: PropTypes.number,
  cityName: PropTypes.string.isRequired,
  size: PropTypes.string,
  seoTitle: PropTypes.string.isRequired
};
